import { render, staticRenderFns } from "./ObjectivesStudentDialog.vue?vue&type=template&id=765e8eb2&scoped=true"
import script from "./ObjectivesStudentDialog.vue?vue&type=script&lang=js"
export * from "./ObjectivesStudentDialog.vue?vue&type=script&lang=js"
import style0 from "./ObjectivesStudentDialog.vue?vue&type=style&index=0&id=765e8eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765e8eb2",
  null
  
)

export default component.exports